import { alpha } from '@mui/material';
import styled from 'styled-components';

export const NodeSidebar = styled.div`
  display: flex;
  flex-direction: column;

  & .MuiTabPanel-root {
    padding: 0;
  }
`;

export const NodeSidebarTab = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 1.25rem;
  padding-top: 1.1rem;
  gap: 1.25rem;
`;

export const NodeSidebarTabsContainer = styled.div<{ color?: string }>`
  padding: 0 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.line.light};

  & .Mui-selected {
    color: ${({ theme, color }) => (color ? color : theme.telnyx.green)} !important;
  }

  & .MuiTabs-root {
    max-height: 50px;
    min-height: 50px;

    .Mui-disabled {
      color: ${({ theme }) => `${alpha(theme.text.standard, 0.2)}`};
    }
  }

  & .MuiSvgIcon-root {
    width: 17px;
    height: 17px;
    font-size: 2.2ch;
    margin-right: 0;
    margin-bottom: 3px;
  }

  & .MuiTab-iconWrapper {
    margin-right: 4px !important;
  }

  & .MuiTab-root {
    display: flex;
    font-family: 'PPFormula';
    padding: 0 10px;
    padding-left: 9px;
    max-height: 57px;
    min-width: 20px;
    min-height: 57px;
    margin-right: 4px;
    font-size: 11px !important;
  }

  & .MuiTabs-indicator {
    background-color: ${({ theme, color }) => (color ? color : theme.telnyx.green)} !important;
  }
`;
